import { SimonSuccess as SimonSuccess$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockSimonSuccess = function BlockSimonSuccess(_ref) {
  var index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  return /*#__PURE__*/React.createElement(SimonSuccess$1, {
    key: index
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
BlockSimonSuccess.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number
} : {};
var SimonSuccess = BlockSimonSuccess;

export { SimonSuccess as default };
